import { render, staticRenderFns } from "./DeleteAliasModal.vue?vue&type=template&id=65a1152b&"
import script from "./DeleteAliasModal.vue?vue&type=script&lang=js&"
export * from "./DeleteAliasModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65a1152b')) {
      api.createRecord('65a1152b', component.options)
    } else {
      api.reload('65a1152b', component.options)
    }
    module.hot.accept("./DeleteAliasModal.vue?vue&type=template&id=65a1152b&", function () {
      api.rerender('65a1152b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Email/DeleteAliasModal.vue"
export default component.exports